module.exports = __webpack_public_path__ + "static/media/child.ba13cd81.png";